<template>
	<widget title="Categories" icon="fa-tag">

		<button type="button" class="btn btn-primary" v-on:click="openEditModal()">
			<i class="fa fa-plus"></i>
			New Category
		</button>

		<table-list
			:records="mutatedCategories"
			:fields="fields"
			record-name="Categorie"
			:hide-record-count="true"
			:has-delete="true"
			:sortable="true"
			:has-edit="true"
			delete-endpoint="/Category/delete"
			v-on:edit="openEditModal"
			v-on:modelChange="modelChange">
		</table-list>


		<modal-dialog
			:modal-visible="editModal.visible"
			:title="editModal.title"
			v-on:closeModal="editModal.visible = false"
			v-on:confirm="saveCategory">

			<template v-if="editModal.payload">

				<field
					label="Category Name"
					col-class="col-sm-4"
					v-model="editModal.payload.name">
				</field>

				<field
					label="Sector"
					col-class="col-sm-4"
					:params="{type:'select',options:sectorOptions}"
					v-model="editModal.payload.sector_id">
				</field>

				<field
					label="Form Child Templates"
					col-class="col-sm-4"
					:params="{ type: 'select-multi', options: formChildTemplateOptions }"
					v-model="editModal.selectedFormChildTemplateIds">
				</field>

				<field
					label="Checklists"
					col-class="col-sm-4"
					:params="{ type: 'select-multi', options: checklistOptions }"
					v-model="editModal.selectedChecklistIds">
				</field>

			</template>

		</modal-dialog>

	</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"


export default {
	name: "CategoryManagerWidget",
	components: {
		Widget,
		TableList,
		Field,
		ModalDialog
	},
	props: ["categories"],
	data(){
		return {
			catName: "",
			sector_id: 0,

			sectors: [],
			checklists: [],
			formChildTemplates: [],
			localCategories: [],

			fields: [
				{label: "Category",             key:"name"},
				{label: "Sector",               key:"sector"},
				{label: "Form Child Templates", key:"formChildTemplatesText"},
				{label: "Checklists",           key:"checklistsText"},
			],

			editModal: {
				visible: false,
				title: "",
				record: null,
				payload: null,
				selectedFormChildTemplateIds: [],
				selectedChecklistIds: []
			}
		} 
	},
	watch: {
		categories() {
			if (this.categories)
				this.localCategories = this.categories
		}
	},
	computed: {
		mutatedCategories() {
			let vm = this

			function stringify(cat, key, displayField) {
				let stringified = ""
				if (key in cat && cat[key]) {
					if (cat[key].length > 0) {
						stringified = cat[key][0][displayField]
						if (cat[key].length > 1)
							stringified += ", and " + (cat[key].length - 1) + " more..."
					}
				}
				return stringified
			}

			return this.localCategories.map(cat => {
				if (cat.sector_id) {
					let sector = vm.sectors.find(sector => sector.id == cat.sector_id)
					if (sector)
						cat.sector = sector.sector
				}

				cat.formChildTemplatesText = stringify(cat, 'FormChildTemplate', 'description')
				cat.checklistsText = stringify(cat, 'Checklist', 'name')

				return cat
			})
		},
		checklistOptions() {
			return this.optionify(this.checklists, 'name')
		},
		formChildTemplateOptions() {
			return this.optionify(this.formChildTemplates, 'description')
		},
		sectorOptions() {
			return this.optionify(this.sectors,"sector")
		}
	},
	methods: {
		saveCategory() {
			let vm = this

			this.editModal.payload.Checklist = this.editModal.selectedChecklistIds
			this.editModal.payload.FormChildTemplate = this.editModal.selectedFormChildTemplateIds

			this.postData("Category/save", this.editModal.payload, true).then(response => {
				if (response.success) {
					vm.editModal.visible = false
					vm.$emit("modelChange")
					vm.fetchCategories()
				}
			})
		},
		modelChange() {
			this.$emit('modelChange')
			this.fetchCategories()
		},
		openEditModal(category=false) {

			if (!category) {
				this.editModal.title = "New Category"
				this.editModal.record = {name: "", sector_id: 0}
			} else {
				this.editModal.title = "Edit Category"
				this.editModal.record = category
			}

			this.editModal.selectedChecklistIds = ('Checklist' in this.editModal.record && this.editModal.record.Checklist) ?
				this.editModal.record.Checklist.map(checklist => checklist.id) : []

			this.editModal.selectedFormChildTemplateIds = ('FormChildTemplate' in this.editModal.record && this.editModal.record.FormChildTemplate) ?
				this.editModal.record.FormChildTemplate.map(fct => fct.id) : []

			this.editModal.payload = this.cloneObj(this.editModal.record)
			this.editModal.visible = true
		},
		fetchCategories() {
			let vm = this

			const params = {
				include: [
					{ model: 'Checklist', fields: ['id', 'name'] },
					{ model: 'FormChildTemplate', fields: ['id', 'description'] }
				]
			}

			this.getJSON("Category/get", params).then(response => {
				vm.localCategories = response.data
			})
		},

		fetchData() {
			const vm = this

			let promises = [
				this.getJSON("JobSector/get"),
				this.getJSON("Checklist/get"),
				this.getJSON("FormChildTemplate/get")
			]

			Promise.all(promises).then(responses => {

				if (responses[0].success)
					vm.sectors = responses[0].data

				if (responses[1].success)
					vm.checklists = responses[1].data

				if (responses[2].success)
					vm.formChildTemplates = responses[2].data
			})
		}
	},
	created() {
		this.fetchData()

		if (!this.categories)
			this.fetchCategories()
		else
			this.localCategories = this.categories
	}
}
</script>